export default function About() {
  const team = [
    'https://public.readdy.ai/ai/img_res/3a6aee1328999198b9c01cead7199b4f.jpg',
    'https://readdy.ai/api/search-image?query=optical%20technician%20portrait%20sepia%20monochrome%20brown%20tones%20professional%20headshot%20friendly%20expression%20eyewear%20specialist%20team%20member%20vintage%20photography%20style&width=200&height=200&seq=team-member-2&orientation=squarish',
    'https://readdy.ai/api/search-image?query=eye%20care%20professional%20portrait%20warm%20sepia%20tones%20vintage%20aesthetic%20professional%20headshot%20optical%20expert%20healthcare%20specialist%20brown%20monochrome&width=200&height=200&seq=team-member-3&orientation=squarish',
    'https://static.readdy.ai/image/1b8131d487c4d2fd3e7c4221ca00b7be/f89212d5e2549d1039a68e9db1ba251c.jpeg',
    'https://readdy.ai/api/search-image?query=optometry%20specialist%20portrait%20sepia%20tone%20vintage%20style%20warm%20brown%20aesthetic%20professional%20headshot%20confident%20professional%20optical%20care%20expert&width=200&height=200&seq=team-member-4&orientation=squarish'
  ];

  return (
    <section id="sobre" className="py-16 md:py-32 px-6 md:px-20 bg-amber-50/30">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-8 md:mb-12">
          <span className="text-gray-500 text-xs font-medium">/Desde 1990</span>
        </div>

        <div className="flex justify-start md:justify-end mb-12 md:mb-20">
          <div className="max-w-3xl">
            <p className="text-2xl md:text-4xl font-light text-gray-800 leading-relaxed" style={{ lineHeight: '1.8' }}>
              Há mais de três décadas transformamos a forma como as pessoas enxergam o mundo. Nossa paixão por excelência e inovação nos tornou referência em cuidado visual personalizado, oferecendo produtos premium e atendimento humanizado.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="text-gray-400 text-sm">
            • Atendimento humanizado
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 md:gap-6">
            <div className="flex -space-x-3">
              {team.map((avatar, index) => (
                <div 
                  key={index}
                  className="w-12 h-12 md:w-16 md:h-16 rounded-full border-4 border-amber-50/30 overflow-hidden"
                  style={{ filter: 'sepia(0.5)' }}
                >
                  <img 
                    src={avatar}
                    alt={`Team member ${index + 1}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              ))}
            </div>

            <p className="text-gray-700 text-sm max-w-xs">
              Equipe especializada com mais de 50 anos de experiência combinada
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}